import { Page } from '@/components';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';
import { Flex, useTableProps } from '@blockanalitica/ui';
import WalletsTable from './WalletsTable';

export default function UpgradeWalletsPage() {
  const { pagination, sorting, filters } = useTableProps({
    filtersDebounceTime: 250,
    pageSize: 10,
    initialSorting: '-balance',
    initialFilters: {
      textSearch: ''
    }
  });
  return (
    <Page title="Wallets">
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSeatchFilter filters={filters} placeholder="Search by wallet" />
      </Flex>
      <WalletsTable
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
